import { IRedIcon } from '@redoc-starter/redoc';

export const CUSTOME_ICON_DATA: IRedIcon[] = [
  { key: 'hr', path: 'assets/images/icons/hr.svg', isSvg: true },
  { key: 'transaction', path: 'assets/images/icons/transaction.svg', isSvg: true },
  { key: 'ecdd', path: 'assets/images/icons/ecdd.svg', isSvg: true },
  { key: 'slider', path: 'assets/images/icons/slider.svg', isSvg: true },
  { key: 'confirm_success', path: 'assets/images/icons/confirm-dialog/success.svg', isSvg: true },
  { key: 'confirm_warning', path: 'assets/images/icons/confirm-dialog/warning.svg', isSvg: true },
  { key: 'confirm_danger', path: 'assets/images/icons/confirm-dialog/danger.svg', isSvg: true },
  'settings',
  { key: 'shortcut', path: 'assets/images/icons/shortcut.svg', isSvg: true },
  { key: 'finance', path: 'assets/images/icons/finance.svg', isSvg: true },
  { key: 'import_csv', path: 'assets/images/icons/import-csv.svg', isSvg: true },
  { key: 'export_csv', path: 'assets/images/icons/export-csv.svg', isSvg: true },
  { key: 'total_commission', path: 'assets/images/icons/total-commission.svg', isSvg: true },
  { key: 'total_deals', path: 'assets/images/icons/total-deals.svg', isSvg: true },
  { key: 'total_volume', path: 'assets/images/icons/total-volume.svg', isSvg: true },
  { key: 'redoc_transparent', path: 'assets/images/brand/redoc_transparent.svg', isSvg: true },
];
